import { render, staticRenderFns } from "./wrong.vue?vue&type=template&id=b8c94938&"
import script from "./wrong.vue?vue&type=script&lang=js&"
export * from "./wrong.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports